<div ngbDropdown container="body" class="dropdown flex-sm-column flex-lg-column">
  @if (labelText) {
    <label [for]="inputId" class="form-control-label">{{ labelText | titlecase }}</label>
  }
  <div class="d-flex" [ngClass]="{ 'flex-row': isHorizontal, 'flex-column': !isHorizontal }">
    @if (!readOnly) {
      <div class="d-flex flex-column">
        <input
          type="text"
          class="form-control dropdown-toggle dropdown"
          [class.w-100]="!isHorizontal"
          [class.custom-invalid]="isInvalid && control.touched"
          (blur)="onBlur()"
          (focus)="onFocus()"
          data-boundary="viewport"
          [disabled]="isDisabled"
          [id]="inputId"
          [name]="name"
          (input)="onInput($event)"
          [ngModel]="inputValue"
          (keyup)="onKeyUp($event)"
          [placeholder]="placeholderValue"
          [tabindex]="inputTabIndex"
          autocomplete="off" />
        <!--    The actual form field is hidden so that we can send the LookupUser object rather than just a string-->
        <span ngbDropdownToggle style="visibility: hidden; display: block"></span>
        <input hidden [formControl]="control" />
        <div id="{{ inputId }}-userList" ngbDropdownMenu class="dropdown-menu">
          @for (user of list; track user; let first = $first) {
            <a
              class="dropdown-item"
              ngbDropdownItem
              (click)="selectUser(user)"
              [class.border-0]="first"
              >{{ user.displayName }}
              @if (user.mail) {
                <span>&nbsp;- {{ user.mail }}</span>
              }
            </a>
          }
          @if (!loading && list?.length === 0 && (this.searchTerm?.length ?? 0) > 2) {
            <a class="dropdown-item border-0 list-no-search" ngbDropdownItem>
              {{ noSearchResultText }} for search term : <b>&nbsp; "{{ this.searchTerm }}"</b>
            </a>
          }
          @if (loading) {
            <a
              class="dropdown-item border-0 list-loader"
              ngbDropdownItem
              style="pointer-events: none">
              <div class="d-flex justify-content-center align-items-center w-100">
                <div class="loading"></div>
              </div>
            </a>
          }
        </div>
      </div>
    }

    @if (isMultiSelect && displayBadge) {
      <div>
        @if (readOnly && control.value.length === 0) {
          <div class="empty-list-text">
            {{ emptyListText }}
          </div>
        } @else {
          <div
            class="filters-selected d-sm-block d-lg-inline-block mt-sm-0"
            [ngClass]="{ 'mt-lg-3 py-2': !isHorizontal, 'ms-lg-3 px-2': isHorizontal }">
            @for (v of control.value; track v) {
              <button
                type="button"
                [disabled]="isDisabled || readOnly"
                (click)="removeUser(v)"
                class="badge btn me-2 mb-2"
                ngClass="{{
                  readOnly
                    ? 'btn-readonly'
                    : isNewUser(v)
                      ? 'btn-newly-added'
                      : 'btn-already-exists'
                }}">
                <span>{{ v.displayName }}</span>
                @if (!readOnly) {
                  <span class="ps-3">×</span>
                }
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
